import { PartnerAcquireRouteItemDto } from "./PartnerAcquireRouteItemDto";

export class RouteAcquireRouteSearchDto {
  public partner: PartnerAcquireRouteItemDto;
  public searchText: string;
}